import { Tabs } from 'antd'

import RemarkItem from './RemarkItem';
import AtachmentItem from './AtachmentItem';
import { useQuery } from '@apollo/client';
import { GET_REMARKS } from '../../Graphql/queries/getQueries';
import Spiner from '../Spiner/Spiner';



const LeadRemarks = ({ leadId }) => {
    const { loading } = useQuery(GET_REMARKS, {
        variables: {
            lead_id: leadId
        },
    })


    const items = [
        { label: 'Remark', key: 'item-1', children: <RemarkItem leadId={leadId} /> },
        { label: 'Attachment', key: 'item-2', children: <AtachmentItem /> },
        { label: 'Duplicate', key: 'item-3', children: 'Duplicate' },

    ];
    if (loading) return <Spiner />

    return (
        <div className='lead_comp_container ' style={{ minWidth: 455, padding: '40px 25px ' }}>
            <Tabs items={items} />
        </div>
    )
}


export default LeadRemarks


